<div class="contenitore">
  <h1>{{challengeInfos?.videos[0].i18nName[translate.currentLang.toUpperCase()]}}</h1>
  <h3>
    {{"BANNER_CHALLENGE.PARTECIPATING_AT" | translate}}
    <span>{{guiService.lastAcceptedChallenge?.i18nName[translate.currentLang.toUpperCase()]}}</span>
  </h3>
  <div class="videos-container">
    <div class="video" *ngFor="let video of guiService.lastAcceptedChallenge.videos" (click)="video.videoBlocked ? null : videoDetail(video, guiService.lastAcceptedChallenge?.i18nName[translate.currentLang.toUpperCase()])">
      <img *ngIf="video.i18nvideoId && video.i18nvideoId[translate.currentLang.toUpperCase()]"
        class="vidyard-player-embed"
        [src]="'https://play.vidyard.com/'+video.i18nvideoId[translate.currentLang.toUpperCase()]+'.jpg'"
        data-v="4" data-type="inline" />
        <p>{{video.i18nName[translate.currentLang.toUpperCase()]}}</p>
        <div class="locked" *ngIf="video.videoBlocked">
          <img src="../../../../assets/img/Lucchetto.png" alt="" class="lock-icon">
      </div>
    </div>
  </div>
  <button class="change-challenge" (click)="changeChallenge()">{{"BANNER_CHALLENGE.CHANGE_CHALL_BTN" | translate}}</button>
</div>
